var _defs, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrow = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.261,
    height: 12.237,
    viewBox: "0 0 21.261 12.237",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#424b5a}.cls-2{fill:none;stroke:#bfc8d8}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(-409.5 -1382.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    d: "M973.787 815.957l4.856 4.856a1.353 1.353 0 0 0 1.915 0l4.856-4.856c.53-.53.352-.958-.4-.958h-10.831c-.748.001-.926.429-.396.958z",
    className: "cls-1",
    transform: "rotate(-90 988.816 1379.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_29",
    d: "M15 0H0",
    className: "cls-2",
    "data-name": "Line 29",
    transform: "translate(409.5 1388.5)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.14bfdcb9.svg";
export { ForwardRef as ReactComponent };